/**
 * A unit float from an integer seed, for the town screens' deterministic
 * scatter (props, scenery, ambient animation). One copy: the same seed used
 * to land on three different values in three files, because each had its own
 * hash with its own way of folding the 32-bit word onto [0, 1).
 *
 * Presentation only. Nothing here reaches the kernel or decides an outcome.
 */
export function hash01(seed: number): number {
  let h = Math.trunc(seed) * 2654435761;
  h = (h ^ (h >>> 13)) * 1274126177;
  h = h ^ (h >>> 16);
  return (h >>> 0) / 4294967296;
}
